import Alert from "antd/lib/alert";
import Button from "antd/lib/button";
import Spin from "antd/lib/spin";
import * as React from "react";

import * as authService from "../../common/authService";
import "./index.css";

export default class Login extends React.PureComponent {
    state = authService.getLoginState();
    setLoginState = () => this.setState(authService.getLoginState());
    constructor() {
        super();
        authService.onLoginStatusChange(this.setLoginState);
    }
    componentWillUnmount() {
        authService.offLoginStatusChange(this.setLoginState);
    }

    renderLoginError() {
        const description = (
            <div>
                <p>{this.state.loginError}</p>
                <p>
                    <span
                        className="page-reload-button"
                        onClick={() => authService.logout()}
                    >
                        {"Reload the page"}
                    </span>
                </p>
            </div>
        );
        return (
            <div className="c-Login">
                <div className="login-error-container">
                    <Alert
                        message="Error logging in"
                        description={description}
                        type="error"
                        showIcon={true}
                    />
                </div>
            </div>
        );
    }
    renderSpinner() {
        return (
            <div className="c-Login">
                <Spin size="large" tip="Logging in..." />
            </div>
        );
    }
    renderLogin() {
        return (
            <div className="c-Login">
                <Button icon="google" size="large" onClick={authService.login}>
                    {"Login with Google"}
                </Button>
            </div>
        );
    }
    renderChildren() {
        return this.props.children;
    }
    render() {
        switch (this.state.loginStatus) {
            case authService.LoginStatus.LoggedIn:
                return this.renderChildren();
            case authService.LoginStatus.LoggedOut:
                return this.renderLogin();
            case authService.LoginStatus.Pending:
                return this.renderSpinner();
            case authService.LoginStatus.LoginError:
                return this.renderLoginError();
            default:
                return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/index.js